import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export interface UserSuccessorAccount {
  ownerUuid: string;
  ownerName: string;
  investmentsCount: number;
}

interface GetUserSuccessorAccountsAdminHookType {
  userUuid?: string;
  enabled?: boolean;
}

export default function useGetUserSuccessorAccountsAdmin({
  userUuid,
  enabled = true,
}: GetUserSuccessorAccountsAdminHookType) {
  return useQuery<UserSuccessorAccount[]>({
    queryKey: ["investments/admin/user/successor-accounts", userUuid],
    queryFn: async () => {
      return axiosInstance
        .get(`/investments/admin/user/${userUuid}/successor-accounts`)
        .then((res) => res.data);
    },
    retry: false,
    enabled: enabled && !!userUuid,
    staleTime: 1000 * 15,
  });
}
